import { takeLatest } from 'redux-saga/effects';
import apiCall from '../../utils/apiCall';
import {
  BLUEBITS_LOGIN,
  BLUEBITS_GET_LOCKERS,
  BLUEBITS_GET_LOCKER_SETTINGS,
  BLUEBITS_GET_LOCKER_PARCELS,
  BLUEBITS_GET_LOCKER_NOTIFICATIONS,
  BLUEMYTH_GET_LOCKERS_FOR_PORTAL,
  BLUEMYTH_LINK_LOCKERS
} from '../constants';

const bluebitsLogin = apiCall({
  type: BLUEBITS_LOGIN,
  method: 'post',
  path: '/bluebits/login'
});

const getBluebitsLockers = apiCall({
  type: BLUEBITS_GET_LOCKERS,
  method: 'post',
  path: '/bluebits/lockers'
});

const getBluebitsLockerSettings = apiCall({
  type: BLUEBITS_GET_LOCKER_SETTINGS,
  method: 'post',
  path: '/bluebits/lockers/settings'
});

const getBluebitsLockerParcels = apiCall({
  type: BLUEBITS_GET_LOCKER_PARCELS,
  method: 'post',
  path: '/bluebits/lockers/parcels'
});

const getBluebitsLockerNotifications = apiCall({
  type: BLUEBITS_GET_LOCKER_NOTIFICATIONS,
  method: 'post',
  path: '/bluebits/lockers/notifications'
});

const getBluemythLockersForPortal = apiCall({
  type: BLUEMYTH_GET_LOCKERS_FOR_PORTAL,
  method: 'get',
  path: ({ excludeLinked }) =>
    `/bluemyth/lockers/for-portal${excludeLinked ? '?exclude_linked=true' : ''}`
});

const linkBluemythLockers = apiCall({
  type: BLUEMYTH_LINK_LOCKERS,
  method: 'post',
  path: '/bluemyth/lockers/link'
});

export default function* bluebitsSaga() {
  yield takeLatest(BLUEBITS_LOGIN, bluebitsLogin);
  yield takeLatest(BLUEBITS_GET_LOCKERS, getBluebitsLockers);
  yield takeLatest(BLUEBITS_GET_LOCKER_SETTINGS, getBluebitsLockerSettings);
  yield takeLatest(BLUEBITS_GET_LOCKER_PARCELS, getBluebitsLockerParcels);
  yield takeLatest(BLUEBITS_GET_LOCKER_NOTIFICATIONS, getBluebitsLockerNotifications);
  yield takeLatest(BLUEMYTH_GET_LOCKERS_FOR_PORTAL, getBluemythLockersForPortal);
  yield takeLatest(BLUEMYTH_LINK_LOCKERS, linkBluemythLockers);
}
